/*
 * @Description:
 * @Date: 2020-06-04 14:25:14
 */
import Vue from "vue";
import Dialog from "./index.vue";
import store from "@/store/index.js";
import router from "@/router/index";
const DialogConstructor = Vue.extend({ ...Dialog, store, router });

let instance;
const initInstance = () => {
  instance = new DialogConstructor({
    el: document.createElement("div"),
  });
};

const xrkDialog = (options) => {
  // if (!instance) {
  initInstance();
  // }
  for (let prop in options) {
    if (options.hasOwnProperty(prop)) {
      instance[prop] = options[prop];
    }
  }
  instance.$mount();
  document.getElementById("app").appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.visible = true;
  });
};
export default xrkDialog;
